<template>
    <div v-show="showMenu">
        <!-- Tombol Tengah Floating -->
        <div class="floating-btn-wrapper">
            <router-link :to="floatingButtonRoute" class="floating-btn">
                <v-icon size="32" color="white">{{ store.user?.type === 5 ? "mdi-qrcode-scan" : (store.user?.type === 2 ? "mdi-check-decagram" : "mdi-swap-vertical") }}</v-icon>
            </router-link>
        </div>

        <!-- Bottom Navigation Modern -->
        <div class="modern-bottom-nav">
            <!-- Sliding Indicator -->
            <div class="sliding-indicator" :style="indicatorStyle"></div>

            <!-- Beranda -->
            <router-link to="/home" class="nav-item" :class="{ 'active': route.name === 'Home' }">
                <div class="icon-container">
                    <v-icon :size="route.name === 'Home' ? 26 : 24">mdi-home-variant-outline</v-icon>
                </div>
                <span class="nav-label">Beranda</span>
            </router-link>

            <!-- Proses (Admin/Type 5) -->
            <router-link v-if="store.user?.type === 5" to="/proses_trans_guru" class="nav-item" :class="{ 'active': route.name === 'Proses Transaksi Guru' }">
                <div class="icon-container">
                    <v-icon :size="route.name === 'Proses Transaksi Guru' ? 26 : 24">mdi-clock-fast</v-icon>
                </div>
                <span class="nav-label">Proses</span>
            </router-link>

            <!-- Riwayat (Guru/Ortu Type 2/3) -->
            <router-link v-if="store.user?.type === 3 || store.user?.type === 2" to="/riwayat" class="nav-item" :class="{ 'active': route.name === 'Riwayat Transaksi' }">
                <div class="icon-container">
                    <v-icon :size="route.name === 'Riwayat Transaksi' ? 26 : 24">mdi-history</v-icon>
                </div>
                <span class="nav-label">Riwayat</span>
            </router-link>

            <!-- Spacer untuk tombol tengah -->
            <div class="nav-spacer"></div>

            <!-- Riwayat (Admin/Type 5) -->
            <router-link v-if="store.user?.type === 5" to="/riwayat" class="nav-item" :class="{ 'active': route.name === 'Riwayat Transaksi' }">
                <div class="icon-container">
                    <v-icon :size="route.name === 'Riwayat Transaksi' ? 26 : 24">mdi-history</v-icon>
                </div>
                <span class="nav-label">Riwayat</span>
            </router-link>

            <!-- Kelas (Guru Type 2) -->
            <router-link v-if="store.user?.type === 2" :to="goToInfo" class="nav-item" :class="{ 'active': isInfoActive }">
                <div class="icon-container">
                    <v-icon :size="isInfoActive ? 26 : 24">mdi-google-classroom</v-icon>
                </div>
                <span class="nav-label">Kelas</span>
            </router-link>

            <!-- AKR Play (Siswa Type 3) -->
            <router-link v-if="store.user?.type === 3" to="/akr-play" class="nav-item" :class="{ 'active': route.name === 'AKR Play' }">
                <div class="icon-container">
                    <v-icon :size="route.name === 'AKR Play' ? 26 : 24">mdi-gamepad-variant-outline</v-icon>
                </div>
                <span class="nav-label">AKR Play</span>
            </router-link>

            <!-- Profil -->
            <router-link to="/profile" class="nav-item" :class="{ 'active': route.name === 'Profile' }">
                <div class="icon-container">
                    <v-icon :size="route.name === 'Profile' ? 26 : 24">mdi-account-outline</v-icon>
                </div>
                <span class="nav-label">Profil</span>
            </router-link>
        </div>
    </div>
</template>

<script setup>
import { ref, watch, computed, onMounted, nextTick } from 'vue'
import { useRoute } from 'vue-router'
import { useMainStore } from '@/store'
import router from '@/router'

const store = useMainStore()
const route = useRoute()
const user = computed(() => store.user)
const userType = computed(() => user.value?.type)
const showMenu = ref(false)

const checkVisibility = () => {
    const hiddenRoutes = ['Login', 'Logout', 'Welcome', 'DetailTransaksi', 'Halaman Tidak Ditemukan', 'Forgot Password', 'Reset Password']
    const isUserTypeHidden = userType.value === 4
    const isRouteHidden = hiddenRoutes.includes(route.name || '')

    showMenu.value = !(isRouteHidden || isUserTypeHidden)
}
onMounted(checkVisibility)
watch(() => route.name, checkVisibility)

const floatingButtonRoute = computed(() => {
    const userType = store.user?.type
    if (userType === 5) return '/penyerahan' 
    if (userType === 3) return '/transaksi' 
    if (userType === 2) return '/verif_transaksi' 
    if (userType !== 2 && userType !== 3) return '/404'
})

const goToInfo = computed(() => {
    const userType = store.user?.type
    if (userType === 3) return '/info_siswa'
    if (userType === 2) return '/info_guru' 
    if (userType !== 2 && userType !== 3) return '/404'
})

const isInfoActive = computed(() => {
    return ['Info', 'Informasi', 'Info Siswa', 'Info Guru', 'Kelas'].includes(route.name)
})

const indicatorStyle = ref({
    left: '0px',
    width: '0px',
    height: '0px',
    top: '0px',
    opacity: 0
})

const updateIndicator = async () => {
    await nextTick()
    setTimeout(() => {
        const activeItem = document.querySelector('.modern-bottom-nav .nav-item.active')
        const parent = document.querySelector('.modern-bottom-nav')
        
        if (activeItem && parent) {
            const rect = activeItem.getBoundingClientRect()
            const parentRect = parent.getBoundingClientRect()
            
            // Ukuran garis bawah tetap (misal 32px)
            const indicatorWidth = 32
            // Posisikan tepat di tengah item yang aktif
            const leftPos = (rect.left - parentRect.left) + (rect.width / 2) - (indicatorWidth / 2)
            
            indicatorStyle.value = {
                left: `${leftPos}px`,
                width: `${indicatorWidth}px`,
                opacity: 1
            }
        } else {
            indicatorStyle.value.opacity = 0
        }
    }, 50)
}

watch(route, updateIndicator)
onMounted(() => {
    updateIndicator()
    window.addEventListener('resize', updateIndicator)
})

</script>

<style scoped>
.modern-bottom-nav {
    position: fixed;
    bottom: 0;
    left: 50%;
    transform: translateX(-50%);
    width: 100%;
    max-width: 480px;
    height: 70px;
    background: rgba(255, 255, 255, 0.85);
    backdrop-filter: blur(20px);
    -webkit-backdrop-filter: blur(20px);
    border-radius: 30px 30px 0 0;
    border-top: 1px solid rgba(255, 255, 255, 0.6);
    border-left: 1px solid rgba(255, 255, 255, 0.3);
    border-right: 1px solid rgba(255, 255, 255, 0.3);
    box-shadow: 0 -4px 30px rgba(0, 0, 0, 0.05);
    display: flex;
    justify-content: center;
    align-items: center;
    padding: 0 5px;
    z-index: 100;
}

.nav-item {
    flex: 1;
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: center;
    text-decoration: none;
    color: #9e9e9e;
    transition: all 0.3s ease;
}

.nav-item.active {
    color: #450a54;
}

.icon-container {
    padding: 4px 12px;
    border-radius: 20px;
    transition: all 0.3s ease;
    display: flex;
    align-items: center;
    justify-content: center;
    position: relative;
    z-index: 1;
}

.sliding-indicator {
    position: absolute;
    bottom: 0;
    height: 4px;
    background: #450a54; /* Warna utama */
    border-radius: 4px 4px 0 0;
    transition: all 0.4s cubic-bezier(0.25, 1, 0.5, 1);
    z-index: 2;
    pointer-events: none;
    box-shadow: 0 -2px 12px rgba(69, 10, 84, 0.8); /* Efek glow menyala */
}

.nav-item.active .icon-container {
    transform: translateY(-4px);
}

.nav-item.active .nav-label {
    transform: translateY(-2px);
}

.nav-label {
    font-size: 10px;
    font-weight: 700;
    margin-top: 4px;
    letter-spacing: 0.2px;
}

.nav-spacer {
    flex: 0 0 65px;
}

.floating-btn-wrapper {
    position: fixed;
    bottom: 35px;
    left: 50%;
    transform: translateX(-50%);
    z-index: 101;
}

.floating-btn {
    width: 64px;
    height: 64px;
    border-radius: 50%;
    background: linear-gradient(135deg, #450a54 0%, #8e24aa 100%);
    display: flex;
    align-items: center;
    justify-content: center;
    box-shadow: 0 8px 20px rgba(69, 10, 84, 0.35);
    border: 5px solid #f4f6f8;
    text-decoration: none;
    transition: all 0.3s cubic-bezier(0.175, 0.885, 0.32, 1.275);
}

/* Biar border nyatu dengan background gradient global */
/* Jika background body berbeda, sesuaikan border */
.floating-btn {
    border-color: rgba(255, 255, 255, 0.8);
}

.floating-btn:hover {
    transform: scale(1.08) translateY(-3px);
    box-shadow: 0 12px 25px rgba(69, 10, 84, 0.45);
}
</style>
